// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const ADD_REVIEW = "P\u0159idej hodnocen\u00ed";
export const BLOGS = "Ze\u010f";
export const counter_REPLIES = ["%(counter)s odpov\u011b\u010f", "%(counter)s odpov\u011bdi", "%(counter)s odpov\u011bd\u00ed"];
export const count_WIKI_ARTICLE_EXPERIENCES = ["%(count)s zku\u0161enost", "%(count)s zku\u0161enosti", "%(count)s zku\u0161enost\u00ed"];
export const FOLLOW_USER = "Sleduj";
export const FORUM_ADD_QUESTION = "Polo\u017e anonymn\u00ed ot\u00e1zku";
export const FORUM_DEFAULT_TOPIC_NAME = "Nezaraden\u00e9";
export const FORUM_READ_MORE = "\u010cti d\u00e1l...";
export const HOME_FORUM_DISCUSSION_HINTS_FOOTER = "Dal\u0161\u00ed zaj\u00edmav\u00e9 diskuse";
export const HOME_FORUM_DISCUSSION_HINTS_TITLE = "Zaj\u00edmav\u00e9 nezodpov\u011bzen\u00e9 nejnov\u011bj\u0161\u00ed diskuse";
export const HOME_FORUM_TOPIC_HINTS_FOOTER = "Vyber jinou kategorii f\u00f3ra";
export const HOME_FORUM_TOPIC_HINTS_TITLE = "Zaj\u00edmav\u00e9 kategorie f\u00f3ra";
export const HOMEPAGE_POST_TYPE_YOUTUBE_MK = "YouTube Modr\u00fd kon\u00edk";
export const JOIN = "Zapoj se";
export const LATEST = "Nejnov\u011bj\u0161\u00ed";
export const NO_REPLIES = "Nezodpov\u011bzeno";
export const READ_OR_ASK = "\u010cti nebo se zeptej";
export const REPLY = "Odpov\u011bz";
export const REVIEW_VERIFIED = "Ov\u011b\u0159en\u00e1 recenze";
export const SEE_CONTESTS = "Prohl\u00e9dni si v\u0161echny sout\u011b\u017ee";
export const SEO_TITLE_CONTESTS = "Sout\u011b\u017ee";
export const SEO_TITLE_COUNSELLINGS = "Poradny";
export const SEO_TITLE_FORUM = "F\u00f3ra";
export const SHARE = "Sd\u00edlej";
export const SUBSCRIBE_TOPIC = "Odeb\u00edrej";
export const TOPIC_COUNSELLOR = "Odborn\u00edk";
